
import { useState } from 'react';

export default function ROISection() {
  const [employees, setEmployees] = useState(50);
  const [years, setYears] = useState(5);

  // 計算ロジック
  const dailyCostPerPerson = 50; // 1日あたり約50円
  const workDaysPerYear = 240;
  const totalDailyCost = dailyCostPerPerson * employees;
  const annualCost = totalDailyCost * workDaysPerYear;
  const totalCost = annualCost * years;

  // 生産性向上効果（年間）
  const productivityGainPerPerson = 120000; // 1人あたり年間12万円の生産性向上
  const annualProductivityGain = productivityGainPerPerson * employees;
  const totalProductivityGain = annualProductivityGain * years;

  // ROI計算
  const roi = ((totalProductivityGain - totalCost) / totalCost * 100).toFixed(0);

  return (
    <section id="roi-simulator" className="py-24 bg-[#fafafa]">
      <div className="max-w-6xl mx-auto px-6">
        {/* Heading */}
        <h2 className="text-4xl font-bold text-center mb-6 leading-tight text-[#1a1a2e]" style={{ fontFamily: 'Noto Serif JP, serif' }}>
          1日あたり、コーヒー1杯以下。<br />
          5年間、社員の健康と成果に投資するという選択。
        </h2>
        <p className="text-center text-lg mb-12 text-[#4a4a4a]">
          MeVERは、役割に応じた3つの価格帯で全社最適を実現します。
        </p>

        {/* Price Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {/* Core */}
          <div className="bg-white rounded-2xl p-8 border-2 border-[#5a5a6e]/20">
            <div className="bg-[#5a5a6e] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
              Core
            </div>
            <h3 className="text-2xl font-bold mb-2 text-[#1a1a2e]">戦略的ミドルレンジ</h3>
            <p className="text-sm text-[#4a4a4a] mb-4">一般企業オフィスにちょうど良い</p>
            <ul className="space-y-2 text-sm text-[#4a4a4a]">
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a5a6e]"></i>
                <span>BIFMA認証</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a5a6e]"></i>
                <span>標準アームレスト</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a5a6e]"></i>
                <span>快適メッシュバック</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a5a6e]"></i>
                <span>コストパフォーマンス重視</span>
              </li>
            </ul>
          </div>

          {/* Pro */}
          <div className="bg-[#8E7CC3] rounded-2xl p-8 text-white transform scale-105 shadow-xl">
            <div className="bg-white text-[#8E7CC3] text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
              Pro - 人気
            </div>
            <h3 className="text-2xl font-bold mb-2">ハイエンドクラス</h3>
            <p className="text-sm text-white/80 mb-4">クリエイター・ビジネスマン向け</p>
            <ul className="space-y-2 text-sm">
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>BIFMA認証</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>6Dアームレスト</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>高剛性アルミフレーム</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line"></i>
                <span>電動昇降デスク最適化</span>
              </li>
            </ul>
          </div>

          {/* Style */}
          <div className="bg-white rounded-2xl p-8 border-2 border-[#5a8a6a]/20">
            <div className="bg-[#5a8a6a] text-white text-xs font-bold px-3 py-1 rounded-full inline-block mb-4">
              Style
            </div>
            <h3 className="text-2xl font-bold mb-2 text-[#1a1a2e]">ウェルネス特化</h3>
            <p className="text-sm text-[#4a4a4a] mb-4">健康志向ユーザー向け</p>
            <ul className="space-y-2 text-sm text-[#4a4a4a]">
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a8a6a]"></i>
                <span>BIFMA認証</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a8a6a]"></i>
                <span>体幹刺激座面</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a8a6a]"></i>
                <span>バランスボール効果</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-check-line text-[#5a8a6a]"></i>
                <span>ナチュラルフィット機構</span>
              </li>
            </ul>
          </div>
        </div>

        <p className="text-center text-sm text-[#4a4a4a] mb-16">
          ※ 役割別導入により、全体コスト最適化が可能です。
        </p>

        {/* ROI Calculator */}
        <div className="bg-white rounded-2xl p-8 md:p-12 border border-[#e8e6e3]">
          <h3 className="text-3xl font-bold text-center mb-8 text-[#1a1a2e]">投資対効果シミュレーター</h3>

          {/* Input Controls */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div>
              <label className="block text-sm font-medium text-[#1a1a2e] mb-4">
                導入人数: <span className="text-2xl font-bold text-[#8E7CC3]">{employees}名</span>
              </label>
              <input
                type="range"
                min="10"
                max="500"
                step="10"
                value={employees}
                onChange={(e) => setEmployees(Number(e.target.value))}
                className="w-full h-2 bg-[#e8e6e3] rounded-lg appearance-none cursor-pointer accent-[#8E7CC3]"
              />
              <div className="flex justify-between text-xs text-[#4a4a4a] mt-2">
                <span>10名</span>
                <span>500名</span>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-[#1a1a2e] mb-4">
                使用期間: <span className="text-2xl font-bold text-[#8E7CC3]">{years}年</span>
              </label>
              <input
                type="range"
                min="1"
                max="10"
                step="1"
                value={years}
                onChange={(e) => setYears(Number(e.target.value))}
                className="w-full h-2 bg-[#e8e6e3] rounded-lg appearance-none cursor-pointer accent-[#8E7CC3]"
              />
              <div className="flex justify-between text-xs text-[#4a4a4a] mt-2">
                <span>1年</span>
                <span>10年</span>
              </div>
            </div>
          </div>

          {/* Results */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-[#fafafa] rounded-xl p-6 text-center">
              <div className="text-sm text-[#4a4a4a] mb-2">1日あたりコスト</div>
              <div className="text-3xl font-bold text-[#1a1a2e]">¥{dailyCostPerPerson}</div>
              <div className="text-xs text-[#4a4a4a] mt-1">/ 人</div>
            </div>

            <div className="bg-[#fafafa] rounded-xl p-6 text-center">
              <div className="text-sm text-[#4a4a4a] mb-2">総投資額（{years}年間）</div>
              <div className="text-3xl font-bold text-[#8E7CC3]">¥{totalCost.toLocaleString()}</div>
              <div className="text-xs text-[#4a4a4a] mt-1">{employees}名 × {years}年</div>
            </div>

            <div className="bg-[#8E7CC3] rounded-xl p-6 text-center text-white">
              <div className="text-sm text-white/80 mb-2">期待ROI</div>
              <div className="text-3xl font-bold">+{roi}%</div>
              <div className="text-xs text-white/80 mt-1">生産性向上効果含む</div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-8 bg-[#fafafa] rounded-xl p-6">
            <h4 className="font-bold text-[#1a1a2e] mb-4 text-center">期待される効果（年間）</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
              <div className="flex items-start space-x-2">
                <i className="ri-check-line text-[#8E7CC3] mt-1"></i>
                <span className="text-[#4a4a4a]">集中力向上による生産性アップ: <strong>約¥{annualProductivityGain.toLocaleString()}</strong></span>
              </div>
              <div className="flex items-start space-x-2">
                <i className="ri-check-line text-[#8E7CC3] mt-1"></i>
                <span className="text-[#4a4a4a]">肩こり・腰痛による欠勤減少</span>
              </div>
              <div className="flex items-start space-x-2">
                <i className="ri-check-line text-[#8E7CC3] mt-1"></i>
                <span className="text-[#4a4a4a]">離職率低下による採用コスト削減</span>
              </div>
              <div className="flex items-start space-x-2">
                <i className="ri-check-line text-[#8E7CC3] mt-1"></i>
                <span className="text-[#4a4a4a]">採用ブランディング強化</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
